import { TGetTransferPricingIntercompanyPairsResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTransferPricingPeriodSelection } from './policy/types';

export function useIntercompanyPairs(
  companyId: number,
  serviceProviderEntityIds?: number[],
  period?: TTransferPricingPeriodSelection
) {
  const queryString = new URLSearchParams();

  if (companyId) {
    queryString.append('companyId', companyId.toString());
  }

  if (serviceProviderEntityIds?.length) {
    queryString.append(
      'serviceProviderEntityIds',
      serviceProviderEntityIds.join(',')
    );
  }

  if (period?.periodType && period?.periodStart) {
    queryString.append('periodType', period.periodType);
    queryString.append('periodStart', period.periodStart);
  }

  const URL = companyId
    ? `transfer-pricing/intercompany-pairs?${queryString.toString()}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TGetTransferPricingIntercompanyPairsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
